import http from '@/lib/http.js';

let strings = {
	GENERIC_ERROR: `Something's wrong`,

	CONNECTION_DOWN_ERROR:
		'Internet connection seems to be spotty. Reconnecting..',
	CONNECTION_ERROR: 'No internet connection. Reconnecting..',
	SERVER_ERROR: `Something's not right. We're looking into this.`,

	RECONNECTION: `We're back online!`,

	NOTES_UPDATED: 'Successfully updated notes.',

	CLIENT_ERROR: 'Something went wrong. Please refresh the dashboard.',
	AUTH_TIMEOUT: 'Your login has expired. Please re-login again.',
	SERVER_ERROR: `Something's wrong on our end. We're looking into this.`,

	COPY: 'Text copied!',
	BOOKMARK: 'Bookmark added!',

	UPDATE_SETTINGS: 'Settings have been saved!'
};

var store = {
	namespaced: true,
	state: {
		type: 'info', //can be info, warning, failure or success
		message: '',
		updateTrigger: false
	},
	getters: {
		message: function(state) {
			return {
				type: state.type,
				message: state.message
			};
		},
		updateTrigger: function(state) {
			return state.updateTrigger;
		}
	},
	mutations: {
		SET_UPDATE_TRIGGER: function(state) {
			state.updateTrigger = !state.updateTrigger;
		},
		SET_TYPE: function(state, type) {
			state.type = type;
		},
		SET_MESSAGE: function(state, message) {
			let str = strings[message];
			if (!str) {
				str = message;
			}
			state.message = str;
		}
	},
	actions: {
		onConnectionWarning: function(context) {
			context.commit('SET_TYPE', 'warning');
			context.commit('SET_MESSAGE', 'CONNECTION_DOWN_ERROR');
			context.commit('SET_UPDATE_TRIGGER');
		},
		onConnectionLost: function(context) {
			context.commit('SET_TYPE', 'failure');
			context.commit('SET_MESSAGE', 'CONNECTION_ERROR');
			context.commit('SET_UPDATE_TRIGGER');
		},
		onReconnection: function(context) {
			context.commit('SET_TYPE', 'success');
			context.commit('SET_MESSAGE', 'RECONNECTION');
			context.commit('SET_UPDATE_TRIGGER');
		},
		onNotesUpdated: function(context) {
			context.commit('SET_TYPE', 'success');
			context.commit('SET_MESSAGE', 'NOTES_UPDATED');
			context.commit('SET_UPDATE_TRIGGER');
		},
		onNetworkError: function(context, type) {
			context.commit('SET_TYPE', 'failure');
			context.commit('SET_MESSAGE', '');

			if (type === 'server') {
				context.commit('SET_MESSAGE', 'SERVER_ERROR');
			}
			if (type === 'client') {
				context.commit('SET_TYPE', 'warning');
				context.commit('SET_MESSAGE', 'CLIENT_ERROR');
			}
			if (type === 'auth:timeout') {
				context.commit('SET_TYPE', 'warning');
				context.commit('SET_MESSAGE', 'AUTH_TIMEOUT');
			}
			context.commit('SET_UPDATE_TRIGGER');
		},
		onCopy: function(store) {
			store.commit('SET_TYPE', 'info');
			store.commit('SET_MESSAGE', 'COPY');
			store.commit('SET_UPDATE_TRIGGER');
		},
		async onMessage(store, str) {
			store.commit('SET_TYPE', 'info');
			store.commit('SET_MESSAGE', str);
			store.commit('SET_UPDATE_TRIGGER');
		}
	}
};

export default store;
